<script lang="ts" setup>
import {
	productSharingData,
	getProductSharingUrl,
} from '@/legacy/ts/productSharing'
import useProductSharing from '@/legacy/ts/useProductSharing'
import injectStrict from '@/lib/inject'
import { instanceProductSharing } from '@/assets/ts/apiManagement'

const props = defineProps({
	postInfo: {
		type: Object,
	},
	width: {
		type: Number,
		default: 14,
	},
	height: {
		type: Number,
		default: 16,
	},
	text: {
		type: Object,
	},
})

const emit = defineEmits(['update-post-info'])
const { isHasPSProfile } = useProductSharing()
const addMessage: (message: string) => void = injectStrict('addMessage')

function like() {
	if (!productSharingData.isLogin) return window.BsHeaderVm.showPanel('login')
	isHasPSProfile().then(isHasPSProfile => {
		if (!isHasPSProfile) {
			window.location.href = getProductSharingUrl('private-index') as string
			return
		}

		const suffix = props.postInfo?.isLiked ? 'unlike' : 'v2/like'
		instanceProductSharing
			.post(`/${suffix}`, {
				post_id: props.postInfo?.id,
			})
			.then(res => {
				const response = {
					isLiked: res.data.data.post.is_liked,
					likeCount: res.data.data.post.like_count,
				}
				emit('update-post-info', {
					likeCount: response.likeCount,
					isLiked: response.isLiked,
				})
			})
			.catch(() => {
				addMessage(props.text?.msg.like)
			})
	})
}

defineExpose({
	like,
})
</script>

<template>
	<div id="bs-like-icon" @click.stop="like">
		<svg
			:class="{ 'bs-like-icon__liked': postInfo?.isLiked }"
			:width="`${width}px`"
			:height="`${height}px`"
			viewBox="0 0 16 16"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g fill="none" fill-rule="evenodd">
				<path
					d="M7.74 14.46C7.82 14.51 7.91 14.53 8 14.53C8.09 14.53 8.18 14.51 8.26 14.46C9.29 13.84 10.29 13.16 11.23 12.43C14.15 10.17 15.43 7.95002 15.13 5.63002C14.98 4.50002 14.31 3.45002 13.35 2.82002C12.44 2.22002 11.36 2.05002 10.27 2.36002C9.4 2.63002 8.64 3.22002 8.01 4.13002C7.37 3.22002 6.61 2.63002 5.68 2.34002C4.64 2.05002 3.56 2.22002 2.64 2.83002C1.66 3.47002 1.02 4.50002 0.87 5.64002C0.57 7.95002 1.85 10.18 4.77 12.43C5.71 13.15 6.71 13.84 7.74 14.46Z"
					id="bs-like-icon-heart"
					stroke="#666666"
					stroke-width="2"
				/>

				<circle id="bs-like-icon-circle" opacity="0" cx="8" cy="8" r="1.5" />
				<g id="bs-like-icon-grp__7" opacity="0" transform="translate(8, 22)">
					<circle id="bs-like-icon-oval1" cx="2" cy="2" r="2" />
					<circle id="bs-like-icon-oval2" cx="2" cy="0" r="2" />
				</g>
				<g id="bs-like-icon-grp__6" opacity="0" transform="translate(0,-3)">
					<circle id="bs-like-icon-oval1" cx="-2" cy="4.5" r="2" />
					<circle id="bs-like-icon-oval2" cx="2" cy="0" r="2" />
				</g>
				<g id="bs-like-icon-grp__5" opacity="0" transform="translate(-6, 6)">
					<circle id="bs-like-icon-oval1" cx="5" cy="5" r="2" />
					<circle id="bs-like-icon-oval2" cx="2" cy="0" r="2" />
				</g>
				<g id="bs-like-icon-grp__4" opacity="0" transform="translate(0, 16)">
					<circle id="bs-like-icon-oval1" cx="5" cy="4" r="2" />
					<circle id="bs-like-icon-oval2" cx="2" cy="0" r="2" />
				</g>
				<g id="bs-like-icon-grp__3" opacity="0" transform="translate(16, 16)">
					<circle id="bs-like-icon-oval1" cx="-1" cy="4" r="2" />
					<circle id="bs-like-icon-oval2" cx="2" cy="0" r="2" />
				</g>
				<g id="bs-like-icon-grp__2" opacity="0" transform="translate(22, 6)">
					<circle id="bs-like-icon-oval1" cx="-1" cy="5" r="2" />
					<circle id="bs-like-icon-oval2" cx="2" cy="0" r="2" />
				</g>
				<g id="bs-like-icon-grp__1" opacity="0" transform="translate(16,-3)">
					<circle id="bs-like-icon-oval1" cx="6" cy="4.5" r="2" />
					<circle id="bs-like-icon-oval2" cx="2" cy="0" r="2" />
				</g>
			</g>
		</svg>
	</div>
</template>
